var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-container',{attrs:{"form":"","wide":""}},[_c('c-book-header',[_vm._v("ステーションを選択")]),(_vm.areas.length === 0)?[_c('c-no-station')]:_vm._l((_vm.areas),function(area){return _c('c-area',{key:area.pref,attrs:{"area":area}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }